module.exports = __webpack_public_path__ + "media/images/photos/gradient2-1ab51aeda469f075e605c8715fdfef23.jpg";